import { getItemsConfig } from 'components/common/func';
import {
  METHOD_DEPOSIT,
  METHOD_EPAYMENT,
  METHOD_PAYID,
  METHOD_PAYTO,
  METHOD_POLI,
} from 'constants';
import {
  PAY_BY_PAYTO_AMOUNT_MAX_LIMIT,
  PAY_BY_PAYTO_AMOUNT_MIN_LIMIT,
} from 'features/to/const';
import { isEmpty } from 'lodash';

const useCountryConfigUtils = (countryConfig) => {
  const payLimitConfig =
    !isEmpty(countryConfig) &&
    getItemsConfig(countryConfig?.payLimits, countryConfig?.countryCode);

  const paymentOptionsConfig =
    !isEmpty(countryConfig) &&
    getItemsConfig(countryConfig?.paymentOptions, countryConfig?.countryCode);

  const getPayLimitRanger = () => ({
    [METHOD_PAYID]: {
      payLimitMin: payLimitConfig['nppMin'],
      payLimitMax: payLimitConfig['nppMax'],
      feesIncluded: payLimitConfig['nppFeesIncluded'],
    },
    [METHOD_POLI]: {
      payLimitMin: payLimitConfig['poliMin'],
      payLimitMax: payLimitConfig['poliMax'],
      feesIncluded: payLimitConfig['poliFeesIncluded'],
    },
    [METHOD_DEPOSIT]: {
      payLimitMin: payLimitConfig['depositMin'],
      payLimitMax: payLimitConfig['depositMax'],
      feesIncluded: payLimitConfig['depositFeesIncluded'],
    },
    [METHOD_EPAYMENT]: {
      payLimitMin: payLimitConfig['epaymentMin'],
      payLimitMax: payLimitConfig['epaymentMax'],
      feesIncluded: payLimitConfig['epaymentFeesIncluded'],
    },
    [METHOD_PAYTO]: {
      payLimitMin: payLimitConfig['payToMin'] || PAY_BY_PAYTO_AMOUNT_MIN_LIMIT,
      payLimitMax: payLimitConfig['payToMax'] || PAY_BY_PAYTO_AMOUNT_MAX_LIMIT,
      feesIncluded: payLimitConfig['payToFeesIncluded'],
    },
  });

  const getPaymentOptionsConfig = () =>
    countryConfig &&
    getItemsConfig(countryConfig?.paymentOptions, countryConfig?.countryCode);

  return {
    payLimitConfig,
    paymentOptionsConfig,
    getPayLimitRanger,
    getPaymentOptionsConfig,
  };
};

export default useCountryConfigUtils;
